import React from 'react';

const Email = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <g>
            <g>
              <path
                d="M19 6c1.105 0 2 .895 2 2v8c0 .287-.06.56-.17.807l.03.031-.084.083C20.443 17.562 19.772 18 19 18H5c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2h14zm-4.044 6.133l-1.965 1.695c-.532.46-1.305.484-1.862.077l-.116-.093-1.638-1.461-4.459 4.644L5 17h14c.182 0 .353-.049.5-.134l-4.544-4.733zm-10.95-4.25L4 8v8c0 .147.032.287.09.413l4.539-4.728-4.555-4.063c-.034.082-.057.17-.067.261zm15.975-.08l-4.267 3.676L20 15.942V8c0-.067-.007-.133-.02-.197zM19 7H5l-.114.006 6.792 6.06c.164.146.4.166.585.059l.075-.054 6.98-6.02c-.064-.02-.132-.036-.201-.044L19 7z"
                transform="translate(-176 -4180) translate(0 3791) translate(176 249) translate(0 140)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Email;
